// @flow
import React from 'react'

const Visa = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0-4h32v32H0z" />
        <g fillRule="nonzero">
          <path
            fill="#111"
            d="M22.549 12.853h1.314c-.468-2.15-.259-1.178-.473-2.18-.129.352-.776 2.012-.841 2.18z"
          />
          <path
            fill="#1A1876"
            d="M29 .5H3A2.503 2.503 0 0 0 .5 3v18c0 1.378 1.121 2.5 2.5 2.5h26c1.378 0 2.5-1.122 2.5-2.5V3c0-1.379-1.122-2.5-2.5-2.5zM9.288 14.909L7.879 9.86a6.657 6.657 0 0 0-1.663-.637l.02-.122H8.79c.345.013.623.123.719.491l.555 2.671.165.806 1.552-3.965h1.678l-2.495 5.802-1.676.003zm5.405.005H13.11l.99-5.813h1.585l-.992 5.813zm2.758.086c-.711-.008-1.396-.148-1.766-.31l.223-1.301c.638.289.993.397 1.696.397.455 0 .944-.178.948-.567.003-.255-.205-.436-.822-.721-.6-.278-1.396-.744-1.388-1.58C16.351 9.788 17.454 9 19.02 9c.614 0 1.105.127 1.42.244l-.216 1.26a2.87 2.87 0 0 0-1.328-.29c-.62 0-.907.258-.907.5-.004.272.335.451.89.72.913.416 1.335.918 1.33 1.58C20.197 14.221 19.116 15 17.45 15zm6.863-.085s-.145-.667-.192-.87l-2.03-.003c-.061.157-.333.873-.333.873h-1.663l2.352-5.326c.167-.379.451-.482.83-.482h1.225l1.282 5.809h-1.47z"
          />
        </g>
      </g>
    </svg>
  )
}

export default Visa



// WEBPACK FOOTER //
// ./src/components/Icons/Visa.js